import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RilevamentoScambiDoppiDTO } from '../models/models/pages/rilevamento-doppi';

@Injectable({ providedIn: 'root' })
export class RilevamentoScambiDoppiService {
    private baseUrl = `${environment.baseApiUrl}/rilevamento-scambi-doppi`;

    private cache = new Map<any, Observable<any[]>>();

    constructor(private http: HttpClient) {}

    // LIST
    list(params?: { page?: number; size?: number; sort?: string }): Observable<any[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<any[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    // GET by id
    get(id: number): Observable<RilevamentoScambiDoppiDTO> {
        return this.http.get<RilevamentoScambiDoppiDTO>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // CREATE
    create(payload: Omit<RilevamentoScambiDoppiDTO, 'id'>): Observable<RilevamentoScambiDoppiDTO> {
        return this.http.post<RilevamentoScambiDoppiDTO>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE
    update(entity: RilevamentoScambiDoppiDTO): Observable<RilevamentoScambiDoppiDTO> {
        return this.http.put<RilevamentoScambiDoppiDTO>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // PATCH
    partialUpdate(id: number, patch: Partial<RilevamentoScambiDoppiDTO>): Observable<RilevamentoScambiDoppiDTO> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<RilevamentoScambiDoppiDTO>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    // DELETE
    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    getOrFetch(deviatoioId: any, fetchFn: () => Observable<any[]>): Observable<any[]> {
        const cacheKey = deviatoioId?.id;

        if (!cacheKey) {
            return of([]);
        }

        if (!this.cache.has(cacheKey)) {
            this.cache.set(cacheKey, fetchFn().pipe(shareReplay(1)));
        }

        return this.cache.get(cacheKey)!;
    }
}
